// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"7633c31a","130":"bc635ba2","572":"7633c31a","864":"bc635ba2","926":"7633c31a","938":"7633c31a","963":"bc635ba2"}[chunkId] + ".chunk.css";
};